// extracted by mini-css-extract-plugin
export var list = "music-title-changer-module--list--1onNQ";